import { getMonthNamesNominative } from './localeUtils';

export const formatCalendarDate = (
  date: Date,
  withYear: boolean = false,
  locale?: string,
) => {
  const months = getMonthNamesNominative(locale);
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return `${months[monthIndex]} ${withYear ? year : ''}`;
};
